export default "__VITE_ASSET__C5V4T9dG__"